import { Lock } from 'lucide-react';
import { EmptyState } from '@/components/ui/EmptyState';

/**
 * What a screen shows when the school does not have its feature switched on —
 * reached by an old bookmark or a shared link, since the menu no longer offers
 * it. Says who can change that rather than leaving a blank page or an error.
 */
export function FeatureNotEnabled({ label }: { label: string }) {
  return (
    <div className="card p-6">
      <EmptyState
        icon={<Lock className="h-6 w-6" />}
        title={`${label} is not enabled for your school`}
        description="This feature has not been switched on for your school. Please contact the school office if you need it."
      />
    </div>
  );
}
